import {
  IRecruiterSearchFilterDTO,
  ISharePhoneNumber,
  ITwilio,
  ITelnyx,
  ICommunicationServiceAccount,
} from 'wisestep-api';

import { ICommunicationAccount } from '../components/CommunicationAccounts';
import { IZoomAccount } from '../components/ZoomAccounts';

export const recruiterAdvancedQueryPayload: IRecruiterSearchFilterDTO = {
  recruiterEmailPhrase: '',
  recruiterFirstNamePhrase: '',
  recruiterLastNamePhrase: '',
  size: 10,
  sort: ['createdOn,DESC'],
  page: 0,
};

export const sharePhoneNumberPayload: ISharePhoneNumber = {
  accountId: '',
  emails: [],
  phoneNumber: '',
};

export const twilioPayload: ITwilio = {
  serviceAccountId: '',
  refreshToken: '',
};

export const telnyxPayload: ITelnyx = {
  accessToken: '',
};

export const mapSmsAccounts = (
  communicationAccounts: ICommunicationServiceAccount[]
): ICommunicationAccount[] => {
  const accounts = communicationAccounts?.[0]?.phoneNumbers ?? [];
  return accounts.map((account, i) => ({
    id: i,
    accountId: i === 0 ? communicationAccounts[0].serviceAccountId : '',
    phoneNumber: account?.phoneNumber ?? '',
    users: account.sharedWith?.length ?? 0,
    sharedWith: account.sharedWith,
    action: '',
  }));
};
export const mapZoomAccounts = (
  communicationAccounts: ICommunicationServiceAccount[]
): IZoomAccount[] => {
  const accounts = communicationAccounts?.[0]?.phoneNumbers ?? [];
  return accounts.map((account, i) => ({
    id: i,
    phoneNumber: account?.phoneNumber ?? '',
    email: account.owners?.[0] ?? '',
    users: account.sharedWith?.length ?? 0,
    sharedWith: account.sharedWith,
    action: '',
  }));
};

export const mapSharedAccount = (initialAssignedRecruiters: string[]) =>
  initialAssignedRecruiters.map((user) => ({ id: user }));
